import * as React from "react";
import { Flex } from "styles/utility-components";

import { generateNoticeSearchUrl, NoticeFilters } from "components/notices/utils";
import Button from "components/ui/button/Button";
import EmptyState from "components/ui/empty_state/EmptyState";
import { NoticesStagesv2 } from "lib/types/graphQLEnums";

type Props = {
  filters: NoticeFilters;
  setFilters: (newValue: React.SetStateAction<NoticeFilters | undefined>) => void;
  selectedViewId?: string;
};

function EmptyAnalysis({ filters, setFilters, selectedViewId }: Props) {
  const handleRemoveStageFiltersClick = () => {
    setFilters((prev) => (prev === undefined ? prev : { ...prev, stage: [] }));
  };

  const editSearchUrl = generateNoticeSearchUrl(filters, selectedViewId ?? undefined, true);

  // TODO: remove "edit search" button once filters can be accessed directly in the analysis page
  return (
    <EmptyState
      type="noResults"
      heading="No results"
      description="Your search doesn't contain any notices to analyse. Try changing the procurement stage filter or widening your overall search."
      size="large"
      width="100%"
      yAxisMargin="auto"
      action={
        <Flex column gap={8}>
          {filters.stage.length > 0 &&
            filters.stage.length !== Object.keys(NoticesStagesv2).length && (
              <Button
                buttonType="secondary"
                icon="xCircle"
                onClick={() => handleRemoveStageFiltersClick()}
              >
                Remove procurement stage filter
              </Button>
            )}
          <Button buttonType="tertiary" blackText icon="edit02" as="a" href={editSearchUrl}>
            Edit my search
          </Button>
        </Flex>
      }
    />
  );
}

export default EmptyAnalysis;
